import { ApplicationInsights, eSeverityLevel } from '@microsoft/applicationinsights-web';

import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';
import { User } from '@common/models';

@Injectable({ providedIn: 'root' })
export class InsightsService {

    /**
     * Application insights API for monitoring
     */
    appInsights: ApplicationInsights;

    /**
     * Constructor for the service
     */
    constructor(){

        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.services.applicationInsights,
                enableAutoRouteTracking: true
                // Sin enableDebugExceptions: convierte los avisos internos del SDK
                // (p. ej. el límite de ajax por page view) en excepciones que
                // revientan la llamada HTTP en curso
            }
        });

        this.appInsights.loadAppInsights();

    }


    setUserContext(user: User){
        if (user){
            this.appInsights.setAuthenticatedUserContext(user?.email, user?.username);
        }
    }


    logPageView(name?: string, url?: string){
        this.appInsights.trackPageView({
            name: name,
            uri: url
        });
    }


    logEvent(name: string, properties?: {[key: string]: any}){
        this.appInsights.trackEvent({name: name}, properties);
    }


    logMetric(name: string, average: number, properties?: {[key: string]: any}){
        this.appInsights.trackMetric({name: name, average: average}, properties);
    }


    logException(exception: Error, severityLevel?: number){
        this.appInsights.trackException({exception: exception, severityLevel: severityLevel});
    }


    logTrace(message: string, properties?: {[key: string]: any}){
        this.appInsights.trackTrace({message: message}, properties);
    }

    customTrace(message:string, securityLevel: number, data: any, user?: User | null){
        if(user != null) this.setUserContext(user);
        this.appInsights.trackTrace({ message: message, severityLevel: securityLevel }, data);
        this.appInsights.flush(true);
    }

    traceInfo(project: string, message: string, data: any, user?: User | null){
        this.customTrace(`${project.toUpperCase()}: ${message}`, eSeverityLevel.Information, { project: project, url: window.location.pathname, obj: JSON.stringify(data)}, user);
    }

    traceError(project: string, message: string, data: any, ex: any, user?: User | null){
        this.customTrace(`${project.toUpperCase()}: ${message}`, eSeverityLevel.Error, { project: project, url: window.location.pathname, obj: JSON.stringify(data), ex: JSON.stringify(ex) }, user);
    }

}
